import { Capacitor } from '@capacitor/core';

/** Capacitor iOS/Android-WebView, nicht Browser. */
export function isNativeApp() {
    return Capacitor.isNativePlatform();
}

/** `npm run build:mobile` – PDF/Admin im App-Bundle ausblenden. Web-Build bleibt unverändert. */
export function isMobileBuild() {
    return process.env.VUE_APP_TARGET === 'mobile';
}
